import { render, staticRenderFns } from "./C19DeclarationReport.vue?vue&type=template&id=bae3c384&scoped=true"
import script from "./C19DeclarationReport.vue?vue&type=script&lang=js"
export * from "./C19DeclarationReport.vue?vue&type=script&lang=js"
import style0 from "./C19DeclarationReport.vue?vue&type=style&index=0&id=bae3c384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae3c384",
  null
  
)

export default component.exports